import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course03 from "../../../course/course-03/course";
import lesson0302 from "../../../lesson/course-03/lesson-02/lesson";
import lesson0306 from "../../../lesson/course-03/lesson-06/lesson";
import lesson0317 from "../../../lesson/course-03/lesson-17/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "72df1b5a-9764-4526-9470-b5826af17546",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0302),
    lesson: lesson0302,
  },
  {
    id: "f97320c7-8358-4f8a-8477-0fcd9cadad78",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0306),
    lesson: lesson0306,
  },
  {
    id: "0651b37c-8efa-4262-9c48-20a721cbdd3a",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0317),
    lesson: lesson0317,
  },
];

export default lessonLinks;
